import type { FC } from 'react'
import React from 'react'

import type { IconProps } from '../../../../ui/components/Icon'
import { Icon } from '../../../../ui/components/Icon'
import bathroomIcon from './icons/bathroom.svg'
import dayEndedIcon from './icons/day-ended.svg'
import externalTaskIcon from './icons/external-task.svg'
import lunchIcon from './icons/lunch.svg'
import snackIcon from './icons/snack.svg'

const icons: Record<string, SpriteSymbol | undefined> = {
  bathroom: bathroomIcon,
  'day-ended': dayEndedIcon,
  'external-task': externalTaskIcon,
  lunch: lunchIcon,
  snack: snackIcon,
}

type DynamicIconProps = Omit<IconProps, 'icon'> & {
  name: string
}

export const DynamicIcon: FC<DynamicIconProps> = ({ name, ...props }) => {
  const icon = icons[name]

  if (icon) {
    return <Icon {...props} icon={icon} />
  }

  return null
}
